import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { useCallback } from 'react'
import { Field } from 'formik'
import { ISalesFunnelClosedReasons } from '@user/store/salesFunnel/typings'
import {
  DebouncedTextField,
  MuiRadioGroupFormik,
} from '@user/components/Formik'
import { ENTITY_TYPES } from '@sales-center/common'

import Box from '@mui/material/Box'

const getStyles = (theme: Theme) => ({
  label: {
    fontSize: '14px',
    marginTop: theme.spacing(2),
    marginBottom: 0,
  },
})

type Props = {
  entityType: ENTITY_TYPES
  closedReasons: ISalesFunnelClosedReasons
  onCustomReasonFocus: () => void
}

export const ClosedReasonField: React.FC<Props> = (props) => {
  const {
    closedReasons: { disqualifyReasons, allowManualDisqualifyReasons },
    onCustomReasonFocus,
    entityType,
  } = props

  const options = React.useMemo(() => {
    const options = disqualifyReasons.map(({ id, reason }) => ({
      label: reason,
      value: id.toString(),
    }))

    if (allowManualDisqualifyReasons) {
      options.push({ label: 'Custom', value: '0' })
    }

    return options
  }, [allowManualDisqualifyReasons, disqualifyReasons])

  const onChangeReason = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setLength(e.target.value.length),
    [],
  )

  const [length, setLength] = React.useState(0)

  const label =
    entityType === ENTITY_TYPES.Lead
      ? 'Disqualified Reason*'
      : 'Closed/Lost Reason*'
  const styles = getStyles(useTheme())
  return (
    <Box mt={2} display="flex" flexDirection="column">
      <Field
        name="closedReason"
        component={MuiRadioGroupFormik}
        label={label}
        labelClassName={styles.label}
        options={options}
        disabled={false}
        radioProps={{ size: 'small' }}
        radioLabelProps={{ size: 'small' }}
      />
      {allowManualDisqualifyReasons ? (
        <Field
          name="customReason"
          component={DebouncedTextField}
          placeholder="Enter Custom Reason"
          onFocus={onCustomReasonFocus}
          inputProps={{ maxLength: 50 }}
          onChange={onChangeReason}
          helperText={`Max character limit 50. Your current count is ${length} /50`}
        />
      ) : null}
    </Box>
  )
}
ClosedReasonField.displayName = 'ClosedReasonField'
